import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRadioUnselected = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 34,
	viewBox: "0 0 32 34",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M29 17C29 12.375 26.5 8.125 22.5 5.75C18.4375 3.4375 13.5 3.4375 9.5 5.75C5.4375 8.125 3 12.375 3 17C3 21.6875 5.4375 25.9375 9.5 28.3125C13.5 30.625 18.4375 30.625 22.5 28.3125C26.5 25.9375 29 21.6875 29 17ZM0 17C0 11.3125 3 6.0625 8 3.1875C12.9375 0.3125 19 0.3125 24 3.1875C28.9375 6.0625 32 11.3125 32 17C32 22.75 28.9375 28 24 30.875C19 33.75 12.9375 33.75 8 30.875C3 28 0 22.75 0 17Z",
		fill: "#636569"
	})
});
export default SvgRadioUnselected;
